module.exports = __webpack_public_path__ + "static/media/1.73c507f2.png";